import { useSelector } from 'react-redux';
import { isMobile } from 'components/Shared/responsive';
import {
  getEfficiencyArrow,
  getEfficiencyDeclarationUrl,
  productIdSelector
} from 'views/ProductPage/selector';
import { ProductPrice } from '../BGH/productInfoHeader/price';
import { AddToCartSection } from 'views/ProductPage/themes/BGH/addToCartSection';
import { EnergyData } from 'components/EnergyData';
import styles from './addToCart.scss';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { PriceGuarantee } from 'views/ProductPage/themes/BGH/productInfoHeader/priceGuarantee';

export const AddToCart = () => {
  const mobile = useSelector(isMobile);
  const productId = useSelector(productIdSelector);
  const efficiencyArrow = useSelector(getEfficiencyArrow);
  const efficiencyDeclarationUrl = useSelector(getEfficiencyDeclarationUrl);

  return (
    <div {...getQaDataAttr('pdp-info')}>
      <ProductPrice isMobile={mobile} />
      <PriceGuarantee addMarginBottom={!mobile} />
      <AddToCartSection />
      <EnergyData
        productId={productId}
        efficiencyArrow={efficiencyArrow}
        efficiencyDeclarationUrl={efficiencyDeclarationUrl}
        arrowWrapperClassName={styles.arrowWrapper}
      />
    </div>
  );
};
